// extracted by mini-css-extract-plugin
export default {"errors":"errors_errors__zF8yS","pass":"errors_pass__SKSoz","strength":"errors_strength__nUo4G","option":"errors_option__8CTXa"};